/**
 * La versión de web-ifc que carga el navegador (el visor 3D y la medición sin visor de «Cambió el plano»): un
 * solo lugar para que las dos midan con el MISMO motor. La vara (`pnpm test:vara-ifc`) usa la del package.json
 * de apps/web, que debe ser esta misma.
 *
 * web-ifc 0.0.78 (antes 0.0.57). La 0.0.57 armaba mal los perfiles en T (IfcTShapeProfileDef: el ala salía con
 * el espesor del alma → −22 % de volumen en los WT de NIST y se dibujaban mal) y los muros a inglete (+4,7 % en
 * FZK-Haus). Medido contra IfcOpenShell 0.8.5 en FZK, NIST, Revit 2016/2019, BasicHouse y Vectorworks: la 0.0.78
 * da el T exacto y no empeora nada salvo los ángulos (L) de NIST, −1,6 % → −2,4 % (el redondeo del filete).
 */
export const WEBIFC_VERSION = '0.0.78';
// Directo de jsdelivr (su build ESM de navegador): desde la 0.0.6x el package.json de web-ifc ya no declara la
// condición "browser" y esm.sh sirve el build de node ("not compiled for this environment").
export const WEBIFC_URL = `https://cdn.jsdelivr.net/npm/web-ifc@${WEBIFC_VERSION}/web-ifc-api.js`;
export const WEBIFC_WASM = `https://cdn.jsdelivr.net/npm/web-ifc@${WEBIFC_VERSION}/`;
